import { Box } from '@mantine/core';
import { useLottie } from 'lottie-react';

import animationData from './animationData.json';

export const ZorroLoaderV2 = () => {
  const { View } = useLottie({
    animationData,
    loop: true,
    autoplay: true,
  });

  return <Box style={{ width: '76px', height: '76px' }}>{View}</Box>;
};

ZorroLoaderV2.displayName = 'ZorroAnimatedLoaderV2';
